// Site navigation overlay: shown (fading in) until the visitor dismisses it with
// one of its buttons, which is remembered for 7 days (cookie shownav=no).

const COOKIE = 'shownav';

const getCookie = (name) => document.cookie.split('; ').find((c) => c.startsWith(name + '='))?.slice(name.length + 1) ?? '';

const setCookie = (name, value, days) => {
    const expires = new Date(Date.now() + days * 24 * 60 * 60 * 1000).toUTCString();
    document.cookie = `${name}=${value}; expires=${expires}`;
};

export default function siteNavigation() {
    document.querySelectorAll('.site-navigation .button').forEach((button) => {
        button.addEventListener('click', () => setCookie(COOKIE, 'no', 7));
    });

    if (getCookie(COOKIE) !== 'no') {
        document.querySelectorAll('.site-navigation').forEach((nav) => {
            nav.style.display = '';
            nav.animate([{opacity: 0}, {opacity: 1}], 200);
        });
    }
}
